/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetOrders200ResponseOrdersInnerItemsInner } from './GetOrders200ResponseOrdersInnerItemsInner';
import {
    GetOrders200ResponseOrdersInnerItemsInnerFromJSON,
    GetOrders200ResponseOrdersInnerItemsInnerFromJSONTyped,
    GetOrders200ResponseOrdersInnerItemsInnerToJSON,
    GetOrders200ResponseOrdersInnerItemsInnerToJSONTyped,
} from './GetOrders200ResponseOrdersInnerItemsInner';
import type { GetOrders200ResponseOrdersInnerProviderStatusInner } from './GetOrders200ResponseOrdersInnerProviderStatusInner';
import {
    GetOrders200ResponseOrdersInnerProviderStatusInnerFromJSON,
    GetOrders200ResponseOrdersInnerProviderStatusInnerFromJSONTyped,
    GetOrders200ResponseOrdersInnerProviderStatusInnerToJSON,
    GetOrders200ResponseOrdersInnerProviderStatusInnerToJSONTyped,
} from './GetOrders200ResponseOrdersInnerProviderStatusInner';

/**
 * 
 * @export
 * @interface GetOrders200ResponseOrdersInner
 */
export interface GetOrders200ResponseOrdersInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrders200ResponseOrdersInner
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof GetOrders200ResponseOrdersInner
     */
    createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof GetOrders200ResponseOrdersInner
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof GetOrders200ResponseOrdersInner
     */
    address?: string;
    /**
     * 
     * @type {Array<GetOrders200ResponseOrdersInnerProviderStatusInner>}
     * @memberof GetOrders200ResponseOrdersInner
     */
    providerStatus: Array<GetOrders200ResponseOrdersInnerProviderStatusInner>;
    /**
     * 
     * @type {Array<GetOrders200ResponseOrdersInnerItemsInner>}
     * @memberof GetOrders200ResponseOrdersInner
     */
    items: Array<GetOrders200ResponseOrdersInnerItemsInner>;
}

/**
 * Check if a given object implements the GetOrders200ResponseOrdersInner interface.
 */
export function instanceOfGetOrders200ResponseOrdersInner(value: object): value is GetOrders200ResponseOrdersInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('providerStatus' in value) || value['providerStatus'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetOrders200ResponseOrdersInnerFromJSON(json: any): GetOrders200ResponseOrdersInner {
    return GetOrders200ResponseOrdersInnerFromJSONTyped(json, false);
}

export function GetOrders200ResponseOrdersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrders200ResponseOrdersInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'total': json['total'],
        'address': json['address'] == null ? undefined : json['address'],
        'providerStatus': ((json['providerStatus'] as Array<any>).map(GetOrders200ResponseOrdersInnerProviderStatusInnerFromJSON)),
        'items': ((json['items'] as Array<any>).map(GetOrders200ResponseOrdersInnerItemsInnerFromJSON)),
    };
}

export function GetOrders200ResponseOrdersInnerToJSON(json: any): GetOrders200ResponseOrdersInner {
    return GetOrders200ResponseOrdersInnerToJSONTyped(json, false);
}

export function GetOrders200ResponseOrdersInnerToJSONTyped(value?: GetOrders200ResponseOrdersInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': ((value['createdAt']).toISOString()),
        'total': value['total'],
        'address': value['address'],
        'providerStatus': ((value['providerStatus'] as Array<any>).map(GetOrders200ResponseOrdersInnerProviderStatusInnerToJSON)),
        'items': ((value['items'] as Array<any>).map(GetOrders200ResponseOrdersInnerItemsInnerToJSON)),
    };
}

